import React from "react"
import RyderLivescoringTournamentHeaderNin9rsView from "@/components/RyderLivescoring/views/nin9rs/RyderLivescoringTournamentHeaderNin9rsView"
import RyderLivescoringTournamentHeaderDefaultView from "@/components/RyderLivescoring/views/default/RyderLivescoringTournamentHeaderDefaultView"

function RyderLivescoringTournamentHeader({ competition, teams, isGroupingView, customDesign }) {
    const teamIds = Object.keys(teams)

    if ("nin9rs" === customDesign) {
        return <RyderLivescoringTournamentHeaderNin9rsView
            competition={competition}
            teams={teams}
            teamIds={teamIds}
            isGroupingView={isGroupingView}
        />
    } else {
        return <RyderLivescoringTournamentHeaderDefaultView
            competition={competition}
            teams={teams}
            teamIds={teamIds}
            isGroupingView={isGroupingView}
        />
    }
}

export default RyderLivescoringTournamentHeader
